import React from 'react';
import loadable from '@loadable/component';

const KeywordsFilter = loadable(
  () =>
    import(
      /* webpackChunkName: "KeywordsFilter.loadable" */ 'app/shared/modules/MobileSRP/Header/FilterModules/KeywordsFilter/component'
    ),
);

class LoadableKeywordsFilter extends React.Component {
  render() {
    return <KeywordsFilter {...this.props} />;
  }
}

export default LoadableKeywordsFilter;
